import { apiFetch } from "../utils/apiFetch";

export type SearchHitType =
  | "contact"
  | "contract"
  | "risk"
  | "damage"
  | "vorgang"
  | "mail"
  | "termin"
  | "document";

export interface SearchHit {
  type: SearchHitType;
  id: number;
  title: string;
  subtitle: string;
  /** Fundstellen-Snippet (type=document): [[…]]-Marker, kein HTML. */
  snippet?: string;
  /** Deep-Link-Route (vom Backend für mail/termin/document gesetzt; sonst aus type+id abgeleitet). */
  route?: string;
}

/**
 * Globale Suche über GET /api/search (RBAC-/tenant-gefilterter Aggregator).
 * `types` schränkt die Domänen ein — so kann die Palette schnelle DB-Domänen und
 * langsame Graph-Domänen (mail/termin) getrennt/parallel abfragen.
 */
export async function globalSearch(
  q: string,
  signal?: AbortSignal,
  types?: SearchHitType[],
): Promise<SearchHit[]> {
  const term = q.trim();
  if (term.length < 2) return [];
  const params: Record<string, string | number> = { q: term };
  if (types && types.length) params.types = types.join(",");
  const { data } = await apiFetch<{ results: SearchHit[] }>("search", { params, signal });
  return data?.results ?? [];
}
